import AdminQuestionsTestIndex from '@/pages/admin/questions/test/Index'
import AdminQuestionsTestAdd from '@/pages/admin/questions/test/Add'
import AdminQuestionsTestEdit from '@/pages/admin/questions/test/Edit'

export default [
  {
    path: '/admin/questions/test',
    name: 'AdminQuestionsTestIndex',
    component: AdminQuestionsTestIndex,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/test/add',
    name: 'AdminQuestionsTestAdd',
    component: AdminQuestionsTestAdd,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  },
  {
    path: '/admin/questions/test/edit/:id',
    name: 'AdminQuestionsTestEdit',
    component: AdminQuestionsTestEdit,
    props: true,
    meta: {
      roles: ['ROLE_ADMIN']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/questions/test.js